export function uniqueById<T extends { id: string }>(items: T[]) {
  const lookup = new Map<string, T>();
  for (const item of items) {
    lookup.set(item.id, item);
  }
  return Array.from(lookup.values());
}
